var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.options).length)?_c('div',{staticClass:"share-product-box"},_vm._l((_vm.socials),function(social){return _c('ShareNetwork',{key:social.name,attrs:{"network":social.class,"url":_vm.currentRoutePath,"title":_vm.options.MetaTitle || _vm.appName}},[_c('v-icon',{class:social.class},[_vm._v(_vm._s(social.name))])],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }